import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class WorkDeliveryNormEssentialApi extends NewviewOaBaseApi { 
    
    public get ControllerName(): any {
        return 'work-delivery-norm-essential'
    }
}